import { CopyButton } from '@/components/CopyButton';
import { Avatar, AvatarFallback } from '@/components/ui/avatar';
import { Label } from '@/components/ui/label';
import { truncateKey } from '@/lib/formatters'; // Use helper
import { Wallet } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { BookmarkAddressButton } from '../bookmark/BookmarkAddressButton';
import { decodeSparkAddress, type NetworkType } from '@/lib/spark/address';
import { useMemo } from 'react';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';

interface AccountHeaderProps {
  spark_address: string;
  is_burn: boolean;
  network: string;
}

export function AccountHeader({ spark_address, is_burn, network }: AccountHeaderProps) {
  // Decode the public key once per address/network change
  const publicKey = useMemo(() => {
    try {
      console.log('spark_address', spark_address);
      console.log('network', network);
      return decodeSparkAddress(spark_address, network.toUpperCase() as NetworkType);
    } catch (error) {
      console.error('Failed to decode Spark public key:', error);
      return null;
    }
  }, [spark_address, network]);

  return (
    <div className="flex items-center space-x-4 mb-6">
      <Avatar className="h-12 w-12">
        <AvatarFallback>
          <Wallet className="h-6 w-6" />
        </AvatarFallback>
      </Avatar>
      <div>
        <Label htmlFor="wallet-address" className="text-xs text-muted-foreground">
          WALLET
        </Label>
        <div className="flex items-center" id="wallet-address">
          {/* Truncate the spark address inside a tooltip */}
          <TooltipProvider delayDuration={100} key={spark_address}>
            <Tooltip>
              <TooltipTrigger asChild>
                <span className="text-lg font-mono mr-2 cursor-default select-text">
                  {truncateKey(spark_address, 10, 10)}
                </span>
              </TooltipTrigger>
              {publicKey && (
                <TooltipContent>
                  <p className="font-mono break-all max-w-xl text-muted-background">{publicKey}</p>
                </TooltipContent>
              )}
            </Tooltip>
          </TooltipProvider>
          <CopyButton textToCopy={spark_address} />
          <BookmarkAddressButton network={network} address={spark_address} />
          {is_burn && (
            <Badge variant="destructive" className="ml-2">
              Burn Address
            </Badge>
          )}
        </div>
      </div>
    </div>
  );
}
